import { http } from '../../axios';
import { localContentPrefix } from '../../../config';

const url = `${localContentPrefix}/v1/localcollectioncontent/:productId/removableCopy`;

export const fetchHasRemovableCopy = async (productId: string) => {
    const response = await http.get<{ readonly hasRemovableCopy: boolean }>(url, { pathParams: { productId } });

    return response.data.hasRemovableCopy;
};
